import { memo, type ReactNode } from 'react';

export type SettingsStatusPillTone = 'ok' | 'warn' | 'error';

export interface SettingsStatusPillProps {
  readonly tone: SettingsStatusPillTone;
  readonly children: ReactNode;
  readonly className?: string;
}

export const SettingsStatusPill = memo(
  ({ tone, children, className = '' }: SettingsStatusPillProps): JSX.Element => {
    const rootClass = ['asp-status-pill', `asp-status-pill--${tone}`, className]
      .filter((part) => part.length > 0)
      .join(' ');

    return <span className={rootClass}>{children}</span>;
  },
);

SettingsStatusPill.displayName = 'SettingsStatusPill';
